import type { Destinations as DestinationsData } from "@/queries/getDestinations";
import type { ReactNode } from "react";
import { Amis } from "./Amis";
import { Logo } from "./Logo";
import { MenuLink } from "./MenuLink";
import { NavigationMenu } from "./NavigationMenu";
import { Side } from "./Side";
import { SideMobile } from "./SideMobile";
import { MobileMenu } from "./mobileMenu";

type Props = {
  basket: ReactNode;
  destinations: DestinationsData;
  isHeaderTransparent: boolean;
  catalogueImage: ReactNode;
  menuThemeCards: ReactNode;
  isHomepage?: boolean;
};
export const HeaderInner = ({
  basket,
  destinations,
  isHeaderTransparent,
  catalogueImage,
  menuThemeCards,
  isHomepage = false,
}: Props) => {
  return (
    <div className="z-10 bg-inherit transition-colors">
      <div className="flex items-center max-xl:justify-between m-auto h-14 xl:h-20 max-w-(--breakpoint-xxl) px-4 xl:pl-16">
        <SideMobile basket={basket} />
        <Logo isHeaderTransparent={isHeaderTransparent} />
        <div className="hidden xl:flex basis-full justify-center gap-4">
          <NavigationMenu
            destinations={destinations}
            isHeaderTransparent={isHeaderTransparent}
            catalogueImage={catalogueImage}
            menuThemeCards={menuThemeCards}
            isHomepage={isHomepage}
          />
          <MenuLink href="/conferenciers/" isHeaderTransparent={isHeaderTransparent}>
            Conférenciers
          </MenuLink>
          <Amis isHeaderTransparent={isHeaderTransparent} />
        </div>
        <Side basket={basket} isHeaderTransparent={isHeaderTransparent} />
        <div className="flex items-center justify-end xl:hidden w-24">
          <MobileMenu destinations={destinations} menuThemeCards={menuThemeCards} />
        </div>
      </div>
    </div>
  );
};
